/* eslint-disable shopify/prefer-early-return */

/* eslint-disable no-undef */
import parseUrl from 'url-parse';
import { getVideoPlayerManager, EVENT_PLAYER_CREATED, EVENT_PLAYER_PROGRESSED } from './videoPlayer'; // metafields for return reveal

var _window = window,
    _window$bt = _window.bt;
_window$bt = _window$bt === void 0 ? {} : _window$bt;
var _window$bt$settings = _window$bt.settings;
_window$bt$settings = _window$bt$settings === void 0 ? {} : _window$bt$settings;
var _window$bt$settings$v = _window$bt$settings.vslDebug,
    enableDebug = _window$bt$settings$v === void 0 ? false : _window$bt$settings$v,
    _window$bt$settings$v2 = _window$bt$settings.vsl;
_window$bt$settings$v2 = _window$bt$settings$v2 === void 0 ? {} : _window$bt$settings$v2;
var _window$bt$settings$v3 = _window$bt$settings$v2.reveal;
_window$bt$settings$v3 = _window$bt$settings$v3 === void 0 ? {} : _window$bt$settings$v3;
var revealVideoSeconds = _window$bt$settings$v3.seconds,
    returnRevealOn = _window$bt$settings$v3.returnReveal,
    wistiaOn = _window$bt$settings$v3.wistia,
    _window$bt$settings$v4 = _window$bt$settings$v3.selector,
    revealSelector = _window$bt$settings$v4 === void 0 ? '#delay' : _window$bt$settings$v4; // grab page url

var pageUrl = parseUrl(window.location.href, true); // attain bypass from url if it exists

var revealBypass = parseInt(pageUrl.query.bypass, 10);
var revealTime = null;

if (isNaN(revealBypass)) {
  revealTime = revealVideoSeconds;
} else {
  console.debug('Reveal bypass activated:', revealBypass);
  revealTime = revealBypass;
}

function getRevealKey() {
  return "".concat(pageUrl.pathname, ".REVEAL");
}

function debugLog() {
  if (enableDebug) {
    var _console;

    (_console = console).debug.apply(_console, arguments);
  }
} // determine if return and reveal is on


if (returnRevealOn === true) {
  // vimeo video parameters
  var returning = window.localStorage.getItem(getRevealKey());
  var revealed = false;

  if (returning === '1') {
    revealed = true;
    debugLog('return reveal');
    $(revealSelector).show();
    window[window.bt.settings.trackersDataLayer].push(function (trackers) {
      trackers.action('VSLReturnReveal');
    });
  } else if (wistiaOn === true) {
    // if wistia is video type time revealed
    window._wq = window._wq || [];

    _wq.push({
      id: '_all',
      onReady: function onReady(video) {
        video.bind('crosstime', revealTime, function () {
          revealed = true;
          debugLog('Reveal activated');
          window.localStorage.setItem(getRevealKey(), '1');
          $(revealSelector).show();
          window[window.bt.settings.trackersDataLayer].push(function (trackers) {
            trackers.action('VSLRevealFirstTime');
          });
        });
      }
    });
  } else {
    var videoManager = getVideoPlayerManager();
    videoManager.subscribe(EVENT_PLAYER_CREATED, function (_ref) {
      var player = _ref.player;
      console.debug('returnReveal playerCreated', player);
      player.subscribe(EVENT_PLAYER_PROGRESSED, function (_ref2) {
        var seconds = _ref2.seconds;

        if (seconds >= revealTime && revealed === false) {
          revealed = true;
          debugLog('Reveal activated');
          window.localStorage.setItem(getRevealKey(), '1');
          $(revealSelector).show();
          window[window.bt.settings.trackersDataLayer].push(function (trackers) {
            trackers.action('VSLRevealFirstTime');
          });
        }
      });
    });
  }
}